// @flow

import { type CustomReceiptsFetchStatus, useCustomReceiptsHandlerContext } from './context';

export function useCustomReceiptsFetchStatus(): CustomReceiptsFetchStatus {
  const customReceiptsContext = useCustomReceiptsHandlerContext();
  return customReceiptsContext.customReceiptsFetchStatus;
}
